import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import OpsotModal from '../ui/OpsotModal/index'
import OpsotButton from '../ui/OpsotButton/index'
import { useGlobalStore } from '../../services/store/store'
import OpsotTypography from '../ui/OpsotTypography/index'

export const SessionTimeout = ({ sessionTime }) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const resetAuth = useGlobalStore((state) => state.resetAuth)
	const userToken = useGlobalStore((state) => state.userToken)
	const setLoggingOut = useGlobalStore((state) => state.setLoggingOut)
	const userTokenExpired = useGlobalStore((state) => state.userTokenExpired)

	const navigate = useNavigate()
	const timer = useRef(null)
	useEffect(() => {
		const handleLogout = () => {
			setIsModalOpen(true)
			setLoggingOut(true)
			resetAuth()
		}
		// // const userEvents = ['keyup', 'mousemove', 'click', 'scroll']
		// const handleUserEvents = () => {
		// 	clearTimeout(timer.current)

		// 	timer.current = setTimeout(() => {
		// 		handleLogout()
		// 	}, sessionTime)
		// }
		const handleCleanup = () => {
			// userEvents.map((event) =>
			// 	window.removeEventListener(event, handleUserEvents)
			// )
			setLoggingOut(false)
			// clearTimeout(timer.current)
		}

		if (userTokenExpired) {
			handleLogout()
			return handleCleanup()
		}

		if (!userToken) {
			return () => {}
		}

		// userEvents.map((event) => window.addEventListener(event, handleUserEvents))

		// handleUserEvents()

		return () => {
			handleCleanup()
		}
	}, [
		navigate,
		resetAuth,
		sessionTime,
		setIsModalOpen,
		userToken,
		setLoggingOut,
		isModalOpen,
		userTokenExpired
	])

	// if (!userToken) {
	// 	return null
	// }

	return (
		<OpsotModal
			isOpen={isModalOpen}
			title="Session ended due to inactivity"
			body={
				<Box>
					<OpsotTypography
						content="For security purposes we’ve logged you out of your session as you have been inactive for a while."
						variant="bodyMediumBlack"
					/>
					<Box component="p">
						<OpsotButton
							text="Return to home"
							variant="contained"
							onClick={() => {
								setIsModalOpen(false)
								navigate('/')
							}}
						/>
					</Box>
				</Box>
			}
			allowClose={false}
		/>
	)
}
